// Font Sizes, weights
export const Sizes = <const>{
	// Main font size
	font: "14pt",
	// Section number font size,
	sectionNumberFont: "20pt",
	// Section title font
	sectionTitleFont: "24pt",
	// Comment font
	commentFont: "12pt",
	// Status bar height
	statusBar: "2em",
	// Menu anchor width
	menuAnchor: "8em",
	// Menu error display string width
	menuErrorString: "8em",
	// Line number column width
	lineNumber: "2.5em",
	// Counter number column width
	counterNumber: "2.5em",
	// Step number column width
	stepNumber: "1em",
	// Padding for cells in the rendered doc
	cellPadding: "2px",
	// Banner triangle size
	bannerTriangle: "10px",
	// Doc instruction size
	instruction: "12em",
	// Doc instruction icon size
	instructionIcon: "2.5em",
	// Collapsed note block icon size
	collapsedNote: "2em",
	// Home page title text size
	titleText: "2.75em",
	// Home page section title text
	sectionTitleText: "35"
};

// Fonts
export const Fonts = {
	// Home page title text font weight
	titleTextWeight: "bold",
	// Home page code block font family
	codeBlockFamily: "monospace"
};

// Under this width, route will be medium
export const FullRouteSizeThreshold = 760;
// Under this width, route will be small
export const MediumRouteSizeThreshold = 500;
